import { FC, useState } from "react";
import { LegacyDesktopFooter } from "../../widgets/footer";
import { HeaderTeamTitleWidget } from "../../widgets/header";
import { Menu, MenuButton } from '../../components/Menu';
import { PremiumPartner } from './../PremiumPartner';
import { ShopIcon, TicketIcon, UsersIcon } from '../Icons';
import { BottomMenu } from '../mobile/BottomMenu';
import { useConfiguration } from "../../hooks/useConfiguration";
import { TeamContext } from "../../types/common";

interface MobileLayoutProps {
    children?: React.ReactNode;
}

export const MobileLayout: FC<MobileLayoutProps> = ({
    children,
}) => {
    const config = useConfiguration();
    const [menuOpened, setMenuOpened] = useState(false);
    const bgUrl = ` bg-[url(https://fcrodina.com/static/images/bg/rodina.jpg)]`;
    const bgClass = "bg-fixed" + bgUrl;

    return (
        <div className={bgClass}>
            <header className="fixed z-50 top-0 left-0 right-0 bg-slate-950 text-white p-2 sm:px-3 flex flex-row gap-3 justify-between items-center">
                <HeaderTeamTitleWidget />
                <div className="flex flex-row gap-3">
                    <PremiumPartner />
                    <MenuButton collapsed={!menuOpened} onClick={() => setMenuOpened(!menuOpened)} />
                </div>
            </header>
            <div className="w-full pt-16 max-w-screen overflow-hidden bg-slate-100 /*bg-[url(https://tickets.fcrodina.com/bg.png)]*/" style={{ fontFamily: 'Futura, sans-serif' }}>
                <Menu collapsed={!menuOpened} onItemSelect={(key: string) => setMenuOpened(false)} />
                {children}
            </div>
            <LegacyDesktopFooter />
            <div className="sm:hidden">
                <BottomMenu items={[
                    { title: 'Билеты', href: 'https://tickets.fcrodina.com/', icon: <TicketIcon /> },
                    { title: 'Магазин', href: 'https://shop.fcrodina.com', icon: <ShopIcon /> },
                ]} />
            </div>
        </div>
    );
}